import React from "react";
import LayoutDemolition from "../components/layout-demolition";
import StatesListNotfound from "../components/states-list-notfound";

const NOZIPPAGEDEMOLITION = ({ pageContext }) => 
{
    const env = pageContext.env;
    const states = pageContext.states.length > 0 ? pageContext.states : [];
    const codes = pageContext.codes.length > 0 ? pageContext.codes : [];
    const code = pageContext.code;  

    const seo_desc = pageContext.seo_desc;
    const seo = 
    {
        url: 'redirect/no-zip-found',
        env: env,
        code: code,
        page: 'home',
        seo_desc: seo_desc
    }

    return (           
        <LayoutDemolition seo={seo} env={env} code={code} footercolor='white'>

            <section class="nozip">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2>Sorry, we found no results for that zip code.</h2>
                            <p>To find a service provider:</p>
                            <p>1) Please select your State below. <br/> 2) From your State page, select the city or town nearest.</p>
                        </div>
                    </div>
                </div>                    
            </section>

            <StatesListNotfound
                states = {states}                        
                title = 'Find Demolition Contractors in All 50 States'
                codes = {codes}
                env = {env}
            />                    

        </LayoutDemolition>
    )
};

export default NOZIPPAGEDEMOLITION;